import React from "react";
import { formatString } from "../helper-components/helper-function";
import { PaymentStatusIcon } from "../../assets/icons/check-icon";

const BadgesComponent = ({ status = "completed",extra=""}) => {
  return (
    <>
      {status === "completed" ? (
        <div
          className={`border border-[var(--success-color)] text-[var(--success-color)]  text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          {formatString(status)}
        </div>
      ) : status === "draft" ? (
        <div
          className={`border border-[var(--draft-color)] text-[var(--draft-color)]  text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          Saved as Draft
        </div>
      ) : status === "paid" ? (
        <div
          className={`bg-[var(--success-color)] text-[#ffffff] flex items-center gap-1  text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          <PaymentStatusIcon status={status} />
          Paid
        </div>
      ) : status === "pending" ? (
        <div className="flex items-center gap-2">
          <span
            className={`text-[var(--pill-badge-text-color)] text-[length:var(--pill-badge-fs)] font-[var(--pill-badge-fw)] px-3 py-1 border-radius bg-[var(--pill-badge-red-bg)]`}
          >
            Pending
          </span>
        </div>
      ) : status === "open" ? (
        <div
          className={`border border-[var(--draft-color)] text-[var(--draft-color)]  text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          Open
        </div>
      ) : status === "closed" ? (
        <div
          className={`border border-[var(--success-color)] text-[var(--success-color)]  text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          Closed
        </div>
      ) : status === "cancelled" ? (
        <div
          className={`border border-[var(--error-color)] text-[var(--error-color)] flex items-center gap-1  text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          Cancelled
        </div>
      ) : status === "success" ? (
        <div
          className={`border border-[var(--success-color)] text-[var(--success-color)]  text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          Success
        </div>
      ) : status === "sales" ? (
        <div
          className={`text-white  text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)]  rounded-full px-3 py-1 w-fit bg-[var(--success-color)] `}
        >
          Sales
        </div>
      ) : status === "purchase" ? (
        <div
          className={`text-white  text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)]  rounded-full px-3 py-1 w-fit bg-[var(--success-color)] `}
        >
          purchase
        </div>
      ) : status === "Active" ? (
        <div
          className={`text-[var(--status-badge-green-fg)] bg-[var(--status-badge-green-bg)] flex items-center gap-1  text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          Active
        </div>
      ) : status === "Paused" ? (
        <div
          className={`text-[var(--status-badge-red-fg)] bg-[var(--status-badge-red-bg)] flex items-center gap-1  text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          Paused
        </div>
      ) : status === "approved" ? (
        <div
          className={`text-[var(--status-badge-green-fg)] bg-[var(--status-badge-green-bg)] border border-[var(--status-badge-green-border)] text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          {formatString(status)}
        </div>
      ) : status === "rejected" || status === "due" ? (
        <div
          className={`text-[var(--status-badge-red-fg)] bg-[var(--status-badge-red-bg)] border border-[var(--status-badge-red-border)] text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          {formatString(status)}
        </div>
      ) : status === "partial" ? (
        <div
          className={`text-[var(--trans-stats-con-orange-fg)] bg-[var(--trans-stats-con-orange-bg)] text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          {formatString(status)+extra}
        </div>
      ) : status === "progress" ? (
        <div
          className={`text-[var(--trans-stats-con-orange-fg)] bg-[var(--trans-stats-con-orange-bg)] text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          In Progress
        </div>
      ) : status === "done" ? (
        <div
          className={`border border-[var(--success-color)] text-[var(--success-color)] text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          Done
        </div>
      ) : status === "progress" ? (
        <div
          className={`text-[var(--trans-stats-con-orange-fg)] bg-[var(--trans-stats-con-orange-bg)] text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          In Progress
        </div>
      ) : status === "done" ? (
        <div
          className={`border border-[var(--success-color)] text-[var(--success-color)] text-[length:--list-table-row-badges-font-size] font-[var(--list-table-row-font-weight)] border-radius px-2 py-1 w-fit`}
        >
          Done
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default BadgesComponent;
